export const modalBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 2,
  width: '100%',
  minWidth: 480,
  maxWidth: 720,
};

export const groupStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 1,
};

export const sectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 1.5,
  padding: 2,
  borderRadius: ({ shape }) => shape.radius.m,
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const sectionFieldsStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 1.5,
};

export const footerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1.5,
  width: '100%',
};

export const emptyStateStyles = {
  display: 'flex',
  justifyContent: 'center',
  padding: 3,
};

export const loadingStateStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 6,
};
